// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__2c9gJ","btnColor":"Button_btnColor__3N9_W","submitBtn":"Button_submitBtn__w7l5P"};